import { render, staticRenderFns } from "./CopFreightSearchSearchBarComponent.vue?vue&type=template&id=0c4a22ea"
import script from "./CopFreightSearchSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./CopFreightSearchSearchBarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports